import { render, staticRenderFns } from "./StaffStatus.vue?vue&type=template&id=361f889f&"
import script from "./StaffStatus.vue?vue&type=script&lang=ts&"
export * from "./StaffStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports